"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EndPoint = exports.STORAGE_KEY = void 0;
exports.STORAGE_KEY = 'strapi.auth.token';
const AuthUrl = {
    signIn: '/auth/local',
    signUp: '/auth/local/register',
    getMe: '/users/me',
};
exports.EndPoint = {
    auth: AuthUrl,
};
